import React from "react";
import {DataTableProps} from "./models";
import {IconChevronLeft, IconChevronRight} from "@tabler/icons-react";

interface PaginationProps extends Omit<DataTableProps<any>, "currentSearch"> {
    auxComp?: React.ReactNode
}

const Pagination: React.FC<PaginationProps> = ({dataTables, currentPage, setPage, currentPageLength, auxComp}) => {
    const recordsFiltered = dataTables ? (dataTables.recordsFiltered ? dataTables.recordsFiltered : 0) : 0;
    const recordsTotal = dataTables ? (dataTables.recordsTotal ? dataTables.recordsTotal : 0) : 0;
    const realPageLength = currentPageLength === -1 ? recordsFiltered : currentPageLength;
    const maxPage = Math.ceil(recordsFiltered / realPageLength); // Math.ceil() rounds a number UP to the nearest integer

    const pages: (number | null)[] = [];
    if (maxPage > 7) {
        pages.push(1);
        if (currentPage <= 4) {
            pages.push(2);
            pages.push(3);
            pages.push(4);
            pages.push(5);
            pages.push(null);
        } else if (currentPage >= maxPage - 3) {
            pages.push(null);
            pages.push(maxPage - 4);
            pages.push(maxPage - 3);
            pages.push(maxPage - 2);
            pages.push(maxPage - 1);
        } else {
            pages.push(null);
            pages.push(currentPage - 1);
            pages.push(currentPage);
            pages.push(currentPage + 1);
            pages.push(null);
        }
        pages.push(maxPage);
    } else {
        for (let ind = 1; ind <= maxPage; ++ind) pages.push((ind));
    }

    const prevPage = () => setPage(currentPage > 1 ? currentPage - 1 : currentPage);
    const nextPage = () => setPage(currentPage + 1 <= maxPage ? currentPage + 1 : currentPage)

    return (<>
        <div className="flex items-center justify-between bg-white px-4 py-3 border-t border-t-gray-200 shadow ring-1 ring-black ring-opacity-5 rounded-b-lg w-auto">
            <div className="flex flex-1 justify-between sm:hidden">
                <a className="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium hover:bg-gray-50 cursor-pointer"
                   onClick={() => prevPage()}>
                    Precedente
                </a>
                <a className="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium hover:bg-gray-50 cursor-pointer"
                   onClick={() => nextPage()}>
                    Successivo
                </a>
            </div>

            <div className="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
                <div className="inline-flex">
                    {auxComp}
                    <p className="text-sm">
                        {recordsFiltered > 0 &&
                            <>Da <span className="font-medium">{((currentPage - 1) * realPageLength) + 1}</span> a <span
                                className="font-medium">{Math.min((currentPage - 1 + 1) * realPageLength, recordsFiltered)}</span> di{' '}
                                <span className="font-medium">{recordsFiltered}</span> elementi</>
                        }
                        {recordsFiltered === 0 &&
                            <span className="text-rose-700">Nessun elemento!</span>
                        }
                        {recordsFiltered < recordsTotal &&
                            <>&nbsp;(filtrati da <span className="font-medium">{recordsTotal}</span> elementi totali)</>
                        }
                    </p>
                </div>

                <div>
                    <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm">
                        <button
                            className="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-2 py-2 text-sm
                            font-medium text-gray-500
                            hover:bg-gray-50 focus:z-20
                            disabled:opacity-25 disabled:cursor-not-allowed"
                            disabled={pages.length < 2}
                            onClick={() => prevPage()}>
                            <IconChevronLeft className="h-5 w-5"/>
                        </button>

                        {pages.map((page, pageIdx) => (
                            <button key={pageIdx}
                                    className={page === currentPage ?
                                        "z-10 relative inline-flex items-center border border-blue-500 bg-blue-50 px-4 py-2 text-sm font-medium text-blue-600 focus:z-20" :
                                        "relative inline-flex items-center border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-500 hover:bg-gray-50 focus:z-20 disabled:cursor-not-allowed"
                                    }
                                    disabled={page === null}
                                    onClick={() => {
                                        if (page) setPage(page)
                                    }}>
                                {page === null ? '...' : page}
                            </button>
                        ))}

                        <button className="relative inline-flex items-center rounded-r-md border border-gray-300 bg-white px-2 py-2
                            text-sm font-medium text-gray-500
                            hover:bg-gray-50 focus:z-20
                            disabled:opacity-25 disabled:cursor-not-allowed"
                                disabled={pages.length < 2}
                                onClick={() => nextPage()}>
                            <IconChevronRight className="h-5 w-5"/>
                        </button>
                    </nav>
                </div>

            </div>
        </div>
    </>);
}
export default Pagination;